import React from 'react';
import { useTheme, usePreset } from '../../lib/ThemeContext';

/**
 * Consent note with policy links, shown above the input while the conversation is empty
 */
export const PolicyConsent: React.FC = () => {
  const { t, privacyPolicyUrl, termsOfServiceUrl } = useTheme();
  const preset = usePreset();
  const isNv = preset === 'nv';
  const isNevi = preset === 'nevi';

  if (!privacyPolicyUrl && !termsOfServiceUrl) return null;

  const linkStyle: React.CSSProperties = {
    color: isNv ? '#FE7338' : isNevi ? '#F9AA66' : 'inherit',
    textDecoration: 'underline',
  };

  return (
    <p
      className="wc-text-[10px] wc-leading-snug wc-text-center wc-m-0 wc-px-6 wc-pt-2"
      style={{
        color: isNv ? 'rgba(46, 46, 46, 0.4)' : isNevi ? 'rgba(251, 251, 251, 0.4)' : 'var(--wc-text-color)',
        opacity: isNv || isNevi ? 1 : 0.35,
        fontFamily: isNv ? "'WC-Involve', sans-serif" : isNevi ? "'WC-Satoshi', system-ui, sans-serif" : undefined,
      }}
    >
      {t.chatIntro.policyConsent}{' '}
      {privacyPolicyUrl && (
        <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer" style={linkStyle}>
          {t.chatIntro.privacyPolicy}
        </a>
      )}
      {privacyPolicyUrl && termsOfServiceUrl && ` ${t.chatIntro.and} `}
      {termsOfServiceUrl && (
        <a href={termsOfServiceUrl} target="_blank" rel="noopener noreferrer" style={linkStyle}>
          {t.chatIntro.termsOfService}
        </a>
      )}
    </p>
  );
};
